import React from 'react';
import { STAGE_LABEL, STAGE_ORDER, stageCls } from '../lib';

/** "Stage": the first-touch cohort's stages, ladder order, as small pills —
 *  the same pill language as StagePill, with the count leading. */
const StageChips: React.FC<{ stages: Record<string, number> }> = ({ stages }) => (
  <span className="inline-flex flex-wrap justify-end gap-1 max-w-[240px]">
    {[...STAGE_ORDER, ...Object.keys(stages).filter((st) => !STAGE_ORDER.includes(st))].filter((st) => stages[st]).map((st) => (
      <span key={st} className={`inline-flex items-baseline gap-1 text-[10.5px] font-medium px-1.5 py-px rounded-full border whitespace-nowrap ${stageCls(st)}`}>
        <b className="num font-semibold">{stages[st]}</b>{STAGE_LABEL[st] ?? st}
      </span>
    ))}
  </span>
);

export { Dash } from './PlatformBits';

export default StageChips;
